:host([light]) {
    & .building_orgs_f,
    & .building_orgs_g {
        fill: #bbdefb;
    }
    & .building_orgs_h,
    & .building_orgs_i {
        fill: #fff;
    }
    & .building_orgs_i,
    & .building_orgs_j,
    & .building_orgs_g {
        fill-rule: evenodd;
    }
    & .building_orgs_j {
        fill: url(#building_orgs_c);
    }
    & .building_orgs_k {
        fill: none;
        stroke: #1a4e85;
        stroke-miterlimit: 10;
        stroke-width: 6px;
    }
    & .building_orgs_l {
        fill: #1a4e85;
    }
}
:host([dark]) {
    & .building_orgs_f,
    & .building_orgs_g {
        fill: #09264a;
    }
    & .building_orgs_h {
        fill: #fff;
    }
    & .building_orgs_h,
    & .building_orgs_g,
    & .building_orgs_i,
    & .building_orgs_j {
        fill-rule: evenodd;
    }
    & .building_orgs_i {
        fill: url(#building_orgs_c);
    }
    & .building_orgs_k,
    & .building_orgs_j {
        fill: #ced4db;
    }
    & .building_orgs_l {
        fill: none;
        stroke: #fff;
        stroke-miterlimit: 10;
        stroke-width: 6px;
    }
}
